import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BlobBlue } from 'site-modules/canvas/components/blob-blue/blob-blue';
import { BlobOrange } from 'site-modules/canvas/components/blob-orange/blob-orange';

import './blob-wrapper.scss';

export function BlobWrapper({ isFixed = false }) {
  return (
    <div
      className={classnames('blob-wrapper overflow-hidden bg-white left-0 right-0 bottom-0', {
        'blob-fixed pos-f': isFixed,
        'pos-a top-0': !isFixed,
      })}
    >
      <BlobBlue />
      <BlobOrange />
    </div>
  );
}

BlobWrapper.propTypes = {
  isFixed: PropTypes.bool,
};
